<template>
  <div class="tag-like-email-input">
    <div class="fake-padding" @click="focusInputFromFakePadding">
      <vue-tags-input
        v-model="text"
        :tags="emails"
        :autocomplete-items="autocompletes"
        :validation="validation"
        :add-on-key="[13, ',', ' ']"
        :separators="[',', ' ']"
        :placeholder="placeholder"
        ref="vueTagsInput"
        @tags-changed="tagsChanged"
      />
    </div>
  </div>
</template>

<script>
import VueTagsInput, { createTags } from '@johmun/vue-tags-input'
import { validateEmail } from '@/utils/String'
import constants from '@/constants'

const EDITABLE_PLACEHOLDER = 'メールアドレスを追加してください'
const UNEDITABLE_PLACEHOLDER = ''

export default {
  name: 'tag-like-email-input',
  data () {
    return {
      emails: [],
      text: '',
      placeholder: EDITABLE_PLACEHOLDER,
      autocompletes: [],
      validation: [{
        classes: 'ti-invalid',
        // 最小文字数もカバーしている
        rule: tag => !validateEmail(tag.text),
      },
      {
        classes: 'ti-invalid',
        rule: tag => tag.text.length > constants.maxEmailLength,
      }]
    }
  },
  components: {
    VueTagsInput,
  },
  props: [
    'defaultEmails',
  ],
  mounted () {
    if (this.defaultEmails == null) return
    this.replaceEmails(this.defaultEmails)
    // 表示時にフォーカスする
    this.$nextTick(() => {
      this.$refs.vueTagsInput.$el.querySelector('input').focus()
    })
  },
  methods: {
    replaceEmails (emails) {
      this.emails = createTags(emails)
      this.$store.commit('updateTagLikeEmailInputEmails', this.emails)
    },
    tagsChanged (newTags) {
      this.emails = newTags
      this.$store.commit('updateTagLikeEmailInputEmails', this.emails)
      if (newTags.length >= constants.maxTagLikeEmailCount) {
        this.placeholder = UNEDITABLE_PLACEHOLDER
      } else {
        this.placeholder = EDITABLE_PLACEHOLDER
      }
    },
    focusInputFromFakePadding () {
      this.$refs.vueTagsInput.$el.querySelector('input').focus()
    },
  },
  watch: {
    'text' () {
      this.$store.commit('updateTagLikeEmailInputText', this.text)

      if (this.text.length < 1) return
      const formData = new FormData()
      formData.append('input', this.text)
      this.$http({
        url: '/test_email_preset/autocomplete',
        type: 'POST',
        params: formData
      }).then(json => {
        this.autocompletes = json.data.emails
      })
    },
  }
}
</script>

<style lang="scss">
.tag-like-email-input {
  .fake-padding {
    .vue-tags-input {
      max-width: 100% !important;
      width: 100%;
      .ti-input {
        max-height: 150px;
        border: none !important;
        overflow-y: scroll;
        // スクロールバーを非表示にする
        -ms-overflow-style: none;
        scrollbar-width: none;
      }
      .ti-tag {
        font-size: 16px;

        // 以下 INDIGO-914 参照
        color: rgba(35, 24, 21, 0.75);
        background-color: #eee;
        &.ti-invalid {
          background-color: #fecaca;
        }
      }
      .ti-input::-webkit-scrollbar {
          display: none;
      }
      input {
        // プレースホルダの文字列の幅と同じにしないと、右側の余白が少ない場合にプレースホルダが見切れてしまう
        min-width: 249px !important;
        font-size: 16px;
      }
    }
    cursor: text;
    height: 150px;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 2px;
    width: 100%;
  }
}
</style>
